import { render, staticRenderFns } from "./rangliste.vue?vue&type=template&id=2175da2e&scoped=true"
import script from "./rangliste.vue?vue&type=script&lang=js"
export * from "./rangliste.vue?vue&type=script&lang=js"
import style0 from "./rangliste.vue?vue&type=style&index=0&id=2175da2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175da2e",
  null
  
)

export default component.exports